/* 馬超傳・第 2 章上半：潼關（上）蒲阪夜襲（建安十六年，211）
 * 史實：《武帝紀》「潛遣徐晃、朱靈等夜渡蒲阪津，據河西爲營。」
 *       《徐晃傳》「賊梁興夜將步騎五千餘人攻晃，晃擊走之。」
 *       裴注引《山陽公載記》：馬超對韓遂說「宜於渭北拒之，不過二十日，河東穀盡，彼必走矣」，韓遂不聽。
 * 流程：夜裡隨梁興攻徐晃、朱靈的河西營。照史實攻不下來（徐晃打不倒），目標是天亮前盡量殺傷曹兵；
 *       天亮後曹軍反擊，帶著兵退回西邊。打完接第二幕「渭口截渡」（def.next），評星在第二幕。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, TROOPS } from '../kit.ts';
import { MEN, band, night } from './machao_kit.ts';
import { XU, START, EXIT } from '../maps/machao_puban.ts';

const LV = 12, DAWN = 80, BACK = 45;
const WEI = { spec: TROOPS.wei, name: '曹兵', hp: 460, maxHp: 460, atk: 20 };

export default {
  id: 'machao-2a', map: 'machao_puban', hero: 'machao',
  next: 'machao-2', // 第二幕：渭口截渡（評星在第二幕）
  title: '第 2 章　潼關（上）', year: '建安十六年（211）',
  brief: {
    quote: [{ text: '潛遣徐晃、朱靈等夜渡蒲阪津，據河西爲營。', src: '《三國志·魏書·武帝紀》' }, { text: '宜於渭北拒之，不過二十日，河東穀盡，彼必走矣。', src: '《山陽公載記》（〈馬超傳〉裴注）' }],
    text: '馬超、韓遂等關西十部起兵，屯據潼關。曹操在潼關前和聯軍相持，暗中派徐晃、朱靈從蒲阪津夜渡黃河，在河西立營。馬超勸韓遂在渭北阻擋，韓遂不聽。梁興帶步騎五千夜襲徐晃，馬超同行。',
    goals: ['夜襲徐晃、朱靈的河西營，天亮前盡量殺傷', '天亮後帶兵退回西邊', '（下半）渭口截渡'],
  },
  words: { ally: '西涼騎', foe: '曹兵' },
  steps: [
    { // 0. 夜襲
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0] + 400; me.y = START[1];
        V.night = true; V.t0 = w.t;
        V.lx = ally(w, MEN.liangxing, me.x - 80, me.y - 90, LV); V.lx.name = '梁興';
        V.men = band(m, me, 8, '西涼騎', { hp: 700, atk: 24 });
        V.camp = [];
        for (let i = 0; i < 18; i++) { const a = (i / 18) * Math.PI * 2, d = 220 + (i % 3) * 150, u = m.foe('huangjin', XU[0] + Math.cos(a) * d, XU[1] + Math.sin(a) * d * 0.6, WEI); u.asleep = i % 3 !== 0; V.camp.push(u); } // 營還沒立穩：多半在帳裡歇著
        V.xh = boss(w, hero('xuhuang'), XU[0] + 100, XU[1], { name: '徐晃', hp: 7000, atk: 44, armor: 10, ms: 220 });
        V.zl = boss(w, MEN.zhuling, XU[0] - 100, XU[1] + 200, { name: '朱靈', hp: 4200, atk: 32, armor: 8, ms: 220 });
        V.slain0 = m.stats.slain;
        m.line('梁興', '曹軍偷渡蒲阪，營還沒立穩。趁夜殺過去！');
        m.after(4, () => m.line('提示', '徐晃治軍嚴整，這座營拿不下來。天亮之前多殺傷曹兵，天一亮就撤。'));
        m.mark('xu', XU[0], XU[1], '徐晃營');
        m.obj('raid', '');
      },
      tick(m, w) {
        const V = m.vars, left = DAWN - (w.t - V.t0);
        V.slainNight = m.stats.slain - V.slain0;
        m.get('raid').text = `夜襲河西營：殺傷曹兵 ${V.slainNight}（${Math.max(0, Math.ceil(left))} 秒後天亮）`;
        // 晃擊走之：徐晃打不倒；徐晃、朱靈守著營中央，不追出營
        if (V.xh.hp < V.xh.maxHp * 0.4) V.xh.hp = V.xh.maxHp * 0.4;
        for (const b of [V.xh, V.zl]) if (b.alive && SG.gd(b.x, b.y, XU[0], XU[1]) > 650) { b.target = null; b.home = [XU[0], XU[1]]; }
        // 帳裡歇著的兵：被打就醒，叫醒旁邊的人
        for (const u of V.camp) if (u.alive && u.asleep) {
          if (u.hp < u.maxHp) { u.asleep = false; for (const o of V.camp) if (o.alive && o.asleep && SG.gd(o.x, o.y, u.x, u.y) < 240) o.asleep = false; }
          else { u.target = null; u.think = 0.5; u.home = [u.x, u.y]; }
        }
        return left <= 0;
      },
    },
    { // 1. 天亮：晃擊走之，撤退
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.night = false; V.t1 = w.t;
        m.done('raid'); m.unmark('xu');
        m.big('天亮了！');
        m.card('賊梁興夜將步騎五千餘人攻晃，晃擊走之。', '《三國志·魏書·徐晃傳》');
        V.lx.hold = EXIT.slice();
        for (const u of m.alive(V.camp).concat([V.xh, V.zl])) { u.asleep = false; u.home = [me.x, me.y]; }
        m.line('馬超', '撤！退回西邊！');
        m.mark('exit', EXIT[0] + 100, EXIT[1], '撤退');
        m.obj('back', '');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, left = BACK - (w.t - V.t1);
        m.get('back').text = `帶兵退回西邊（${Math.max(0, Math.ceil(left))} 秒）`;
        for (const u of m.alive(V.camp).concat([V.xh, V.zl])) if (!(u.target && u.target.alive)) u.home = [me.x, me.y];
        if (left <= 0) { m.lose('被曹軍追上，沒能退回來'); return false; }
        if (!m.near(me, EXIT[0] + 100, EXIT[1], 300)) return false;
        V.backN = m.alive(V.men).length;
        m.done('back');
        m.line('馬超', '徐晃已經在河西立營了……曹操接下來要從潼關北渡黃河。');
        m.after(3, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('馬超陣亡'); return; }
    if (V.lx) { allyTick(w, V.lx, V.lx.hold ? null : w.player, 500); if (V.lx.hp < V.lx.maxHp * 0.25) V.lx.hp = V.lx.maxHp * 0.25; } // 梁興這一戰沒死
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.night) night(ctx, x0, y0, vw, vh); },
};
